import { BaseType } from '../base/base-type';
import { MemberAccountStatusIdEnum } from './enum/member-account-status-id.enum';

export class MemberAccountStatus extends BaseType {
  public declare id: MemberAccountStatusIdEnum;
}
